/* Action Types */
export const LOAD_BIDDER_PREFERENCE_FAIL = 'LOAD_BIDDER_PREFERENCE_FAIL';
export const LOAD_BIDDER_PREFERENCE_REQUEST = 'LOAD_BIDDER_PREFERENCE_REQUEST';
export const LOAD_BIDDER_PREFERENCE_SUCCESS = 'LOAD_BIDDER_PREFERENCE_SUCCESS';

export const POST_BIDDER_PREFERENCE_FAIL = 'POST_BIDDER_PREFERENCE_FAIL';
export const POST_BIDDER_PREFERENCE_REQUEST = 'POST_BIDDER_PREFERENCE_REQUEST';
export const POST_BIDDER_PREFERENCE_SUCCESS = 'POST_BIDDER_PREFERENCE_SUCCESS';
